import {MapContainer,TileLayer,GeoJSON} from'react-leaflet'
import 'leaflet/dist/leaflet.css'
import { useLocation } from 'react-router'
import { ChoroplethLegend } from '../Utils/choroplethLegend'
import { Legend } from '../Utils/Legends'
import distbase from '../basemaps/dist_base.json'
import "./leaflet-pulse/L.Icon.Pulse.css";
import "./leaflet-pulse/L.Icon.Pulse.js";
import L from 'leaflet';
import '@ansur/leaflet-pulse-icon'
import '../pulse.css'
import { LoadingModal } from '../Utils/Loader'
import {ISPLegend} from '../Utils/LIMS_legend';

import React, { useEffect, useState } from 'react'
import api from '../api/api'

export const Map = () => {
  //const location = useLocation();


  const [isLoading, setIsLoading] = useState(false);
  //const {id,name,alias} = location.state
  //const data = {id:id,report:alias}
  const [layerData,setLayerData] = useState(null)
  // Add new state for facilities data
  const [facilitiesLayer, setFacilitiesLayer] = useState(null);
  const [towersLayer, setTowersLayer] = useState(null);
  const [towersBufferLayer, setTowersBufferLayer] = useState(null);


  function styleFuncFac (feature,latlng) {
        console.log('feature',feature)
        // Define the color based on the feature's properties
        console.log('method called')
        const color = '#FFA500'//getChoroplethColorDist(feature['properties'][indicator],ranges)
        var pulsingIcon = L.icon.pulse({iconSize:[20,20],color:color,fillColor:color});
        // Use a circle marker with custom styles
        return L.marker(latlng, {
            icon: pulsingIcon
        });
    }

// Add this function to handle zoom events
function onZoomEnd(e, layer, tooltip) {
  const zoom = e.target.getZoom();
  if (zoom >= 9) {
    layer.openTooltip();
  } else {
    layer.closeTooltip();
  }
}


  // Add click handler function
  /*
const handleFeatureClick = async (feature) => {
  setIsLoading(true);
  try {
    // Remove existing facilities layer if any
    setFacilitiesLayer(null);
    
    const response = await api.post('/facilities', {
      id: id,
      report:alias,
      district: feature.properties.district
    });
    
    // Set new facilities data
    setFacilitiesLayer(response.data);
  } catch (error) {
    console.error('Error fetching facilities:', error);
  } finally {
    setIsLoading(false);
  }
};*/

const facilitiesStyle = {
  radius: 8,
  fillColor: "#ff7800",
  color: "#000",
  weight: 1,
  opacity: 1,
  fillOpacity: 0.8
};

/*
function onEachFeature(feature, layer) {
  console.log('eac feature')
  layer.on({
    mouseover: onhover,
    click: () => handleFeatureClick(feature)
  });
  
  layer.bindTooltip(feature.properties.district, {
    permanent: true,
    direction: 'center',
    className: 'featureLabel'
  });
}*/

  const  baseStyle = {
    fillColor:'gray',
    fillOpacity:1,
    weight:0.5,
    color:'white'
  };



  function onhover(e) {
    var popup_text = '';
    var hover_marker = e.target;
    var props = Object.keys(hover_marker.feature.properties);
    var unwanted_props = ['district_n', 'region_nam', 'level1', 'level2'];
  
    var property_object = hover_marker.feature.properties;
  
    for (var v = 0; v < props.length; v++) {
      var prop_name = props[v];
      var prop_value = property_object[prop_name];
  
      if (prop_value != null && prop_name !== 'id' && !unwanted_props.includes(prop_name)) {
        var proper_name = prop_name.replace(/_/g, ' ').replace(/District/gi, '').trim();
        var facilitiesCount = 0;
  
        if (typeof facilitiesLayer !== 'undefined' && facilitiesLayer.features) {
          facilitiesCount = facilitiesLayer.features.filter(
            f => f.properties && f.properties.district === prop_value
          ).length;
        }
  
        popup_text += `<p><strong>District:</strong> ${prop_value}</p>`;
        popup_text += `<p><strong>Facilities:</strong> ${facilitiesCount}</p>`;
      }
    }
  
    hover_marker.bindPopup(popup_text, { maxWidth: 'auto', autoPan: false });
    hover_marker.openPopup();
  }
  





function onhoverFac(e){
  var popup_text = ' '
  var hover_marker = e.target
  var props = Object.keys(e.target['feature']['properties']);
  

  
  var unwanted_props2 = ['district_n','region_nam','level1','level2'];
  var property_object = hover_marker.feature['properties']
  
  popup_text = ``
  for(var v = 0;v<props.length;v++){
      var prop_value = property_object[props[v]]

      if(prop_value != null && props[v] != 'id'){
      var proper_name = props[v].replace(/_/g,' ').replace(/District/g,' ')
      popup_text+= "<P> Facility: " + prop_value.toLocaleString() + "</P>" 
      }
      
}

  //hover_marker.bindPopup(popup_text,{maxwidth:'auto',autoPan:false})
  //hover_marker.openPopup()

}

function onEachFeature(feature,layer){
  
  layer.on({
      mouseover:onhover,
      //click: () => handleFeatureClick(feature)
  })
  layer.bindTooltip(feature['properties']['district'],
  {permanent:true,
  direction:'center',
  className:'featureLabel'
  })

}


function onEachFeatureFac(feature,layer){
  layer.on({
      mouseover:onhoverFac,
  })
  
  // Get the facility name
  const facilityName = feature.properties.site_name;
  
  // Replace 'Health Centre' with 'HC' while keeping the first word
  const displayName = facilityName.replace('Health Centre', 'HC');
  /*
  const tooltip = layer.bindTooltip(displayName, {
    permanent: true,
    direction: 'center',
    className: 'featureLabel'
  });*/
/*

  // Get map instance and handle zoom
  layer.on('add', function() {
    const map = layer._map;
    if (map) {
      const zoom = map.getZoom();
      if (zoom < 8) {
        layer.closeTooltip();
      }
      map.on('zoomend', (e) => onZoomEnd(e, layer, tooltip));
    }
  });*/
}



const style = (feature)=>{
    return{
        fillColor: '#FF9149', //getChoroplethColorDist(feature['properties']['number_of_partners']),
        weight:0.5,
        color:'white',
        fillOpacity:1.0
    }
}

useEffect(() => {
  const fetchMapData = async () => {
    setIsLoading(true);
    try {
      const response = await api.get('/limsFacilities');
      console.log(response);
      setLayerData(response.data.districts);
      setFacilitiesLayer(response.data.facilities)
      setTowersLayer(response.data.towers)
      setTowersBufferLayer(response.data.towersbuffer)
    } catch (error) {
      console.error('Error fetching map data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchMapData();
}, []);

  return (
    <LoadingModal isLoading={isLoading}>
    <MapContainer center={[-13.96361780613868, 33.78500398397487]} zoom={7}>
      <TileLayer 
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <GeoJSON data={distbase.features} style={baseStyle} />
      {layerData && 
        <GeoJSON 
          data={layerData} 
          style={style} 
          onEachFeature={onEachFeature}
        />
      }
      {facilitiesLayer &&
  <GeoJSON
    data={facilitiesLayer}
    onEachFeature={onEachFeatureFac}
    pointToLayer={(feature, latlng) => {
      const ispValue = feature.properties.isp ? feature.properties.isp.toUpperCase() : null;

      // Default color for null/empty ISP
      let color = "yellow";

      if (ispValue) {
        if (ispValue.includes("TNM") && ispValue.includes("STARLINK")) color = "purple";
        else if (ispValue.includes("AIRTEL") && ispValue.includes("TNM")) color = "orange";
        else if (ispValue.includes("AIRTEL") && ispValue.includes("STARLINK")) color = "pink";
        else if (ispValue.includes("TNM")) color = "red";
        else if (ispValue.includes("AIRTEL")) color = "blue";
        else if (ispValue.includes("STARLINK")) color = "green";
        else if (ispValue.includes("FIBRE")) color = "brown";
        else if (ispValue.includes("MOH WAN")) color = "black";
      }

      return L.circleMarker(latlng, {
        radius: 8,
        fillColor: color,
        color: color,
        weight: 1,
        opacity: 1,
        fillOpacity: 0.8
      });
    }}
  />
}
      {towersLayer &&
  <GeoJSON
    data={towersLayer}
    pointToLayer={(feature, latlng) => {
      const pulsingIcon = L.icon.pulse({
        iconSize: [12, 12],  // size of the pulsing circle
        color: "red",        // pulse ring color
        fillColor: "red",    // inner dot color
        animate: true,
        heartbeat: 1
      });

      return L.marker(latlng, { icon: pulsingIcon });
    }}
  />
}
      {towersBufferLayer &&
  <GeoJSON
    data={towersBufferLayer}
    style={{
      color: 'blue',
      weight: 1,
      fillColor: 'lightblue',
      fillOpacity: 0.3
    }}
  />
}

      {facilitiesLayer && <ISPLegend Program={`EMR`} />}
    </MapContainer>
    </LoadingModal>
  );
}